export default __webpack_public_path__ + "static/media/404-error.b23186df.jpg";